export default {
  addItem: {
    position: 'fixed',
    right: 200,
    top: 35,
    zIndex: 1100,
  },
  removeItem: {
    position: 'fixed',
    right: 270,
    top: 35,
    zIndex: 1100,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  wrapper: {
    marginTop: 20,
    marginBottom: 80,
  },
  referenceCol: {
    width: 100,
  },
  customerCol: {
    width: 180,
  },
  descriptionCol: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  primaryContactCol: {
    width: 180,
  },
  startCol: {
    width: 110,
  },
  endCol: {
    width: 150,
  },
  tasksCol: {
    width: 100,
  },
  createdCol: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 190,
  },
  actionCol: {
    width: 130,
  },
};



// WEBPACK FOOTER //
// ./src/components/Jobs/styles.js